<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="6">
        <el-card class="box-card" shadow="hover">
          <el-header>
            <span  style="font-size:25px;font-family:PingFang SC">视频总数</span>
          </el-header>
          <el-main>
            <div style="font-size:25px;">{{videoCount}}</div>
            <el-divider content-position="left">月新增</el-divider>
            <span>{{videoAdd}}</span>
          </el-main>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="box-card" shadow="hover">
          <el-header>
            <span style="font-size:25px;font-family:PingFang SC">视频集总数</span>
          </el-header>
          <el-main>
            <div style="font-size:25px;">{{groupCount}}</div>
            <el-divider content-position="left">月新增</el-divider>
            <span>{{groupAdd}}</span>
          </el-main>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="box-card" shadow="hover">
          <el-header>
            <span style="font-size:25px;font-family:PingFang SC">30日累计下载量</span>
          </el-header>
          <el-main>
            <div style="font-size:25px;">{{visitAndDown.downCount}}</div>
            <el-divider content-position="left">日均下载量</el-divider>
            <span>{{fomatFloat(visitAndDown.downCount/30, 1)}}</span>
          </el-main>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="box-card" shadow="hover">
          <el-header>
            <span style="font-size:25px;font-family:PingFang SC">30日累计访问量</span>
          </el-header>
          <el-main>
            <div style="font-size:25px;">{{visitAndDown.viewCount}}</div>
            <el-divider content-position="left">日均访问量</el-divider>
            <span>{{fomatFloat(visitAndDown.viewCount/30,1)}}</span>
          </el-main>
        </el-card>
      </el-col>
    </el-row>
    <p>&nbsp;</p>
    <el-row :gutter="20">
      <el-col :span="24">
        <el-card class="box-card" shadow="hover">
          <el-header>
            <el-row style=" text-align:right">
              <el-col :span="12">
                <el-menu
                  :default-active="activeIndex"
                  class="el-menu-demo"
                  mode="horizontal"
                  @select="handleSelect"
                >
                  <el-menu-item index="1">访问量</el-menu-item>
                  <el-menu-item index="2">下载量</el-menu-item>
                  <el-menu-item index="3">分享数</el-menu-item>
                </el-menu>
              </el-col>
              <el-col :span="12">
                <div class="fr">
                  <el-radio-group v-model="videorank" size="small">
                    <el-radio-button label="1">今日</el-radio-button>
                    <el-radio-button label="2">本周</el-radio-button>
                    <el-radio-button label="3">本月</el-radio-button>
                    <el-radio-button label="4">全年</el-radio-button>
                  </el-radio-group>
                </div>
              </el-col>
            </el-row>
          </el-header>
          <el-row>
            <el-col :span="16">
              <div id="print-content">
                <div id="myChart2" :style="{width: '100%', height: '500px'}"></div>
                <div ref="box"></div>
              </div>
            </el-col>

            <el-col :span="8">
              <!--视频排名-->
              <el-row style="text-align:right">
                <el-button size="small" @click="importpic('videoranklistpic')">导出图片</el-button>
              </el-row>
              <div id = "videoranklistpic">
              <el-table v-loading="loading" :data="videoranklist" style="width: 100%">
                <el-table-column label="排序" width="50">
                  <template slot-scope="scope">
                    <span v-if="scope.row.sort<=3" style="color: red">{{scope.row.sort}}</span>
                    <span v-else>{{scope.row.sort}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="name" label="视频名称"></el-table-column>
                <el-table-column prop="count" v-if="videoranktype==1" label="访问量"></el-table-column>
                <el-table-column prop="count" v-if="videoranktype==2" label="下载量"></el-table-column>
                <el-table-column prop="count" v-if="videoranktype==3" label="分享数"></el-table-column>
              </el-table>
              </div>
            </el-col>

          </el-row>
        </el-card>
      </el-col>
    </el-row>
    <p>&nbsp;</p>
    <!--      //搜索关键字，视频分类饼状图-->
    <el-row :gutter="20">
      <el-col :span="12">
        <el-card class="box-card" shadow="hover">
          <span>搜索关键字</span>
          <el-divider></el-divider>
          <el-radio-group v-model="keywordtime" size="small">
            <el-radio-button label="1">昨日</el-radio-button>
            <el-radio-button label="2">7天</el-radio-button>
            <el-radio-button label="3">30天</el-radio-button>
          </el-radio-group>
          <el-button size="small" @click="importpic('searchranklist')">导出图片</el-button>
          <div id="searchranklist">
          <el-table :data="keywordlist" style="width: 100%">
            <el-table-column label="排序">
              <template slot-scope="scope">
                <span v-if="scope.row.sort<=3" style="color: red">{{scope.row.sort}}</span>
                <span v-else>{{scope.row.sort}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="关键字"></el-table-column>
            <el-table-column prop="count" label="搜索次数"></el-table-column>
          </el-table>
          </div>
        </el-card>
      </el-col>
      <!--    //饼状图-->
      <el-col :span="12">
        <el-card class="box-card" shadow="hover">
          <div style="width: 100%;height: 500px">
          <span>视频分类占比</span>
          <el-divider></el-divider>
          <el-radio-group v-model="cateNum" size="small">
            <el-radio-button label="0">视频数</el-radio-button>
            <el-radio-button label="1">访问量</el-radio-button>
            <el-radio-button label="2">下载量</el-radio-button>
          </el-radio-group>
          <div id="pieChart" :style="{width: '100%', height: '350px'}"></div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <p>&nbsp;</p>
    <!--//成片入库、素材入库，账号登录排名-->
    <el-row :gutter="20">
      <el-col :span="16">
        <el-card class="box-card" shadow="hover">
          <el-header >
            <el-row style="border-bottom:1px solid #e6e6e6;">
              <el-col :span="24">
                <el-menu
                  :default-active="activeIndex"
                  class="el-menu-demo"
                  mode="horizontal"
                  @select="handleSelect2"
                >
                  <el-menu-item index="0">素材入库趋势</el-menu-item>
                  <el-menu-item index="1">成片入库趋势</el-menu-item>
                </el-menu>
              </el-col>
            </el-row>
          </el-header>
          <div id="myChart" :style="{width: '100%', height: '500px'}"></div>

        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card class="box-card" shadow="hover">
          <span>账号登录排名</span>
          <el-divider></el-divider>
          <el-radio-group v-model="loginrank" size="small">
            <el-radio-button label="1">昨日</el-radio-button>
            <el-radio-button label="2">7天</el-radio-button>
            <el-radio-button label="3">30天</el-radio-button>
          </el-radio-group>
          <el-button size="small" @click="importpic('loginranklist')">导出图片</el-button>
          <div id="loginranklist">
          <el-table :data="loginCount" style="width: 100%">
            <el-table-column label="排序" width="50">
              <template slot-scope="scope">
                <span v-if="scope.row.sort<=3" style="color: red">{{scope.row.sort}}</span>
                <span v-else>{{scope.row.sort}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="username" label="名字"></el-table-column>
            <el-table-column prop="loginCount" label="登录次数"></el-table-column>
          </el-table>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import ElHeader from "element-ui/packages/header/src/main";
import ElDivider from "element-ui/packages/divider/src/main";
import ElCard from "element-ui/packages/card/src/main";
import ElRadio from "element-ui/packages/radio/src/radio";
import ElRadioButton from "element-ui/packages/radio/src/radio-button";
import VePie from "v-charts/lib/pie.common";
import html2canvas from 'html2canvas'

export default {
  components: { ElRadioButton, ElRadio, ElCard, ElDivider, ElHeader },
  components: {
    VePie
  },
  data() {
    this.grid = {
      backgroundColor: "rgb(255,255,255 )"
    };
    return {
      loading:true,
      //30日下载与访问量
      visitAndDown:{},
      //视频排名
      conlum:'',
      conlum2:'',
      piecount:'',
      title1: {},
      videorank: 1,
      //分享数、下载量、访问数
      videoranktype:1,
      //柱形图数据
      mychart2Data:{},
      videoranklist: [],
      //视频总数视频集总数
      videoCount: "",
      groupCount: "",
      //视频月新增与视频集月新增
      videoAdd: "",
      groupAdd: "",
      activeIndex: "1",
      activeIndex2: "1",
      //搜索关键字用的周日月
      keywordtime: 1,
      keywordlist: [],
      //饼状图的周日月
      //0视频数，1访问量，2下载量
      cateNum: 0,
      movietime: "0",
      contentType: 0,
      //素材/成片入库
      videoType:0,
      videoTypename:'',
      videoTypetime:[],
      videoTypeData:[],
      //饼图数据
      catePie: {},
      //登录排名
      loginrank: 1,
      loginCount: []
    };
  },
  methods: {
    initringConfig: function(e, f) {
      this.title1 = {
        text: e,
        subtext: f,
        x: "center",
        y: "center",
        itemGap: 20,
        textStyle: {
          color: "#868686",
          fontFamily: "微软雅黑",
          fontSize: 35,
          fontWeight: "bolder"
        }
      };
    },
    //map转数组
    datatolist: function(data, name, count) {
      var id = "";
      var arr = [];
      var i = 1;
      for (var key in data) {
        arr.push({
          sort: i,
          name: key,
          count: data[key]
        });
        i = i + 1;
        if (i > 8) {
          break;
        }
      }
      return arr;
    },
      datatoarr:function(data){
        var arr = [];
        for (var key in data) {
          arr.push(key)
        }
      },

    listlimit: function(list, name, count) {
      var arr = [];
      for (var i = 0; i < list.length; i++) {
        arr.push({
          sort: i + 1,
          username: list[i].username,
          loginCount: list[i].loginCount
        });
        if (i > 8) {
          break;
        }
      }
      return arr;
    },
    //list变成想要的数据
    listtoarr: function(list, name, count) {
      var arr = [];
      for (var i = 0; i < list.length; i++) {
        arr.push({
          sort: i + 1,
          name: list[i].createUser,
          count: list[i].downCount
        });
        if (i > 8) {
          break;
        }
      }
      return arr;
    },

    getVideoRanklist: async function() {
      this.loading=true;
      var res = await this.$http.get(
        `/v1/statistics/videoSort?time=${this.videorank}&type=${this.videoranktype}`
      );
      var { data, message, code } = res.data;
      if (code == 0) {
        if(this.videoranktype==1||this.videoranktype==3){
          this.videoranklist = this.datatolist(data);
          this.loading=false;
        }else {
          this.videoranklist=this.listtoarr(data);
          this.loading=false;
        }
      }
    },
    //获取视频与视频集统计总数
    getVideoCount: async function() {
      var res = await this.$http.get(`/v1/statistics/videoCount`);
      var { data, code, message } = res.data;
      if (code == 0) {
        this.videoCount = data.videoCount;
        this.groupCount = data.groupCount;
        this.videoAdd = data.videoMonthCount;
        this.groupAdd = data.groupMonthCount;
      }
    },
    //获取关键字搜索排名
    getKeywordsCount: async function() {
      var res = await this.$http.get(
        `/v1/statistics/keywordsCount?time=${this.keywordtime}`
      );
      var { data, code, message } = res.data;
      if (code == 0) {
       /* var list = this.datatolist(data);*/
        this.keywordlist = data;
      }
    },
    getLoginCount: async function() {
      var res = await this.$http.get(
        `/v1/statistics/loginCount?time=${this.loginrank}`
      );
      var { data, code, message } = res.data;
      if (code == 0) {
        this.loginCount = this.listlimit(data);
      }
    },
    getDownAndVisit: async function() {
      var res = await this.$http.get(
        `/v1/statistics/videoTypeProportion?contentType=${this.cateNum}`
      );
      var { data, code, message } = res.data;
      if (code == 0) {
        if (this.cateNum == 0) {
          this.conlum = "视频数";
          this.conlum2="总视频数";
          this.piecount = data.count;
        } else if (this.cateNum == 1) {
          this.conlum = "访问量";
          this.conlum2="总访问量";
          this.piecount = data.count;
        } else {
          this.conlum = "下载量";
          this.conlum2="总下载量";
          this.piecount = data.count;
        }
        this.catePie= data;
      }
    },
    //点击分享数、下载数时更改的方法
    handleSelect(key, keyPath) {
     this.videoranktype=key;

     this.createE();
    },
    handleSelect2(key, keyPath) {
      this.videoType=key;
      this.getTypeData();
      this.createE();
    },

    //chart图标导出图片
   /* createImage: function(e) {
      this.$nextTick(() => {});
      var a = e.currentTarget.parentElement;

      const canvas = a.getElementsByTagName("canvas")[0];

      let image = canvas.toDataURL({
        type: "png",
        pixelRatio: 2
      });
      /!* var elink = document.createElement('a');
          elink.download = "图片1.png";
          elink.style.display = 'none';
          elink.href = image;
          document.body.appendChild(elink);
          elink.click();
          document.body.removeChild(elink);*!/
      this.downloadFile("测试.png", image);
    },*/
    base64ToBlob: function(code) {
      let parts = code.split(";base64,");
      let contentType = parts[0].split(":")[1];
      let raw = window.atob(parts[1]);
      let rawLength = raw.length;

      let uInt8Array = new Uint8Array(rawLength);

      for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
      }
      return new Blob([uInt8Array], { type: contentType });
    },
    downloadFile: function(fileName, content) {
      let aLink = document.createElement("a");
      let blob = this.base64ToBlob(content); //new Blob([content]);

      let evt = document.createEvent("HTMLEvents");
      evt.initEvent("click", true, true); //initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
      aLink.download = fileName;
      aLink.href = URL.createObjectURL(blob);
      aLink.dispatchEvent(
        new MouseEvent("click", {
          bubbles: true,
          cancelable: true,
          view: window
        })
      ); //兼容火狐
    },

    createE:async function(){
      var that = this;
      await this.getMychart2Data();
      await this.getDownAndVisit();
      await this.getTypeData();
      this.getVideoRanklist();
      //获取数据的接口方法在这里写
      let pieChart = this.$echarts.init(document.getElementById("pieChart"));
      let myChart = this.$echarts.init(document.getElementById("myChart"));
      let myChart2 = this.$echarts.init(document.getElementById("myChart2"));
      myChart.setOption({
        color: ['#3398DB'],
        tooltip : {
          trigger: 'axis',
          axisPointer : {            // 坐标轴指示器，坐标轴触发有效
            type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        toolbox: {
          show: true,
          feature: {
            saveAsImage: {}
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis : [
          {
            type : 'category',
            data :this.videoTypetime,
            axisTick: {
              alignWithLabel: true
            }
          }
        ],
        yAxis : [
          {
            type : 'value'
          }
        ],
        series : [
          {
            name:this.videoTypename,
            type:'bar',
            barWidth: '60%',
            data:this.videoTypeData,
          }
        ]
      });
      myChart2.setOption({
        color: ['#3398DB'],
        tooltip : {
          trigger: 'axis',
          axisPointer : {            // 坐标轴指示器，坐标轴触发有效
            type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        toolbox: {
          show: true,
          feature: {
            saveAsImage: {}
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis : [
          {
            type : 'category',
            //近七天
          /*  data : ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],*/
            data:this.mychart2Data.time,
            axisTick: {
              alignWithLabel: true
            }
          }
        ],
        yAxis : [
          {
            type : 'value'
          }
        ],
        series : [
          {
            //访问，下载，分享数
            name:this.mychart2Data.name,
            type:'bar',
            barWidth: '60%',
            data:this.mychart2Data.data
          }
        ]
      });
      pieChart.setOption({
        tooltip: {
          trigger: 'item',
          formatter: "{a} <br/>{b}: {c} ({d}%)"
        },
        legend: {
          orient: 'left',
          x: 'left',
          data:(function() {
            var arr = that.datatoarr(that.catePie.proportion);
            // console.log(that.videoGrossCount.categoryCount)
            // for(var i = 0;i<that.videoGrossCount.categoryCount;i++){
            //   console.log('iiiii',that.videoInfoGrossCount.categoryCount[i])
            //   // arr.push(i.category)
            // }
            // console.log('aaaaa',arr)
            return arr;
          })()
        },
        toolbox: {
          show: true,
          feature: {
            saveAsImage: {}
          }
        },
        graphic:[{
          type:'text',
          left:'center',
          top:'40%',
          style:{
            text:that.piecount,
            fill:'#000',
            width:50,
            height:50,
            fontSize:50,
          }
        },{
          type:'text',
          left:'center',
          top:'55%',
          style:{
            text:that.conlum2,
            fill:'#000',
            width:20,
            height:20,
            fontSize:18,
          }
        }],
        series: [
          {
            name:that.conlum,
            type:'pie',
            radius: ['90%', '70%'],
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false,
                position: 'center'
              },
              emphasis: {
                show: false,
                textStyle: {
                  fontSize: '30',
                  fontWeight: 'bold'
                }
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            data:that.catePie.proportion
          }
        ]})
    },

    importpic:function (res) {
      this.$message.success("导出成功");
      let that = this;
      event.preventDefault();
      var canvas2 = document.createElement("canvas");
      let _canvas = document.getElementById(res);
      var w = parseFloat(window.getComputedStyle(_canvas).width);
      var h = parseFloat(window.getComputedStyle(_canvas).height)*1.25;
      //将canvas画布放大若干倍，然后盛放在较小的容器内，就显得不模糊了
      canvas2.width = w;
      canvas2.height = h;
      canvas2.style.width = w + "px";
      canvas2.style.height = h + "px";
      //可以按照自己的需求，对context的参数修改,translate指的是偏移量
      //  var context = canvas.getContext("2d");
      //  context.translate(0,0);
    /*  var context = canvas2.getContext("2d");
      context.scale(2, 2);*/
      html2canvas(document.getElementById(res), {
        canvas: canvas2
      }).then(function (canvas) {

        let image = canvas.toDataURL({
          type: "png",
          pixelRatio: 2
        });
        let name ='';
        if(res=='videoranklistpic'){
          name='图片排行';
        }else if(res=='searchranklist'){
          name='搜索关键字排行'
        }else {
          name='账号登录排行'
        }

        var elink = document.createElement('a');
        elink.download =name;
        elink.style.display = 'none';
        elink.href = image;
        document.body.appendChild(elink);
        elink.click();
        document.body.removeChild(elink);
      /*  this.downloadFile("测试.png", image);*/
      });
    },

    getMychart2Data:async function () {
      var res =await this.$http.get(
        `/v1/statistics/videoSortRank?type=${this.videoranktype}`
      );
      var {data,code,message}= res.data;
      if(code==0){
       this.mychart2Data=data;
      }
    },
    getTypeData:async function () {
      var res = await this.$http.get(
        `/v1/statistics/videoTypeRank?type=${this.videoType}`
      )
      var {code,data,message} = res.data;
      if(code==0){
       this.videoTypename=data.name;
       this.videoTypeData=data.data;
       console.log(this.videoTypeData);
       this.videoTypetime=data.time;
      }
    },
    getDownCountAndVisit:async function () {
        var res = await this.$http.get(
          `/v1/statistics/downAndVicitCount`
        )
      var {code,message,data} = res.data;
      if(code==0){
        this.visitAndDown = data;
      }
    },
    fomatFloat:function(src,pos){
     return Math.round(src*Math.pow(10, pos))/Math.pow(10, pos);
  }
},
  mounted() {
    this.getVideoCount();
    this.getKeywordsCount();
    this.getLoginCount();
    // this.getVideoRanklist();
    this.getDownCountAndVisit();

    this.createE();
  },
  watch: {
    keywordtime: {
      handler: function(newName, oldName) {
        this.getKeywordsCount();
      }
    },
    loginrank: {
      handler: function(newName, oldName) {
        this.getLoginCount();
      }
    },
    videorank: {
      handler: function(newName, oldName) {
        this.getVideoRanklist();
      }
    },
    cateNum: {
      handler: function(newName, oldName) {
        this.createE();
      }
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/backgroundMg/log-mg/analyse.vue